const rightColumnData = {
  title: "Today's Specials",
  items: [
    {
      label: "Chef's Special",
      text: "Hyderabadi Dum Biryani – ₹450"
    },
    {
      label: "Appetizer Special",
      text: "Tandoori Platter – ₹380"
    },
    {
      label: "Dessert Special",
      text: "Gulab Jamun with rabri – ₹120"
    },
    {
      label: "Thali Special",
      text: "Royal Rajasthani Thali – ₹350"
    }
  ]
};

export default rightColumnData;
